export default class SSOToken {
  userid: number;
  token: string;
  error: string;
}
